module.exports = __webpack_public_path__ + "img/IT0000440845319.d0e75f4f.png";